import React, { useState } from 'react'

import { Box, Button, TextField, Typography } from '@material-ui/core'
import { useLocation } from 'react-router-dom'
import qs from 'query-string'

import { BasePhoneInput, LoadingFeedback } from 'components'
import useTrainingJourney from 'hooks/useTrainingJourney'
import useSnackbar from 'hooks/useSnackbar'
import helpers from 'helpers'
import * as service from 'service'
import constants from 'constants/index'
import useStyles from './styles'

const IdentificationStep = () => {
  const classes = useStyles()
  const snackbar = useSnackbar()
  const { search } = useLocation()

  const { matchEmail } = qs.parse(search)

  const [isLoading, setIsLoading] = useState(false)
  const [authMethod, setAuthMethod] = useState('email')
  const [email, setEmail] = useState(matchEmail || '')
  const [phone, setPhone] = useState(constants.countries.DEFAULT_DDI)

  const { accessType, company, handleNext, setFormData } = useTrainingJourney()

  const isEmailMethod = authMethod === 'email'

  const hasValidPhone = phone.replace(/\D/g, '').length >= 10
  const isValid = isEmailMethod ? !!email.trim() : hasValidPhone

  const HandleSetFormData = () => {
    if (isEmailMethod) {
      setFormData({ email: email.trim() })
    } else {
      setFormData({ phone })
    }
  }

  const handleSubmit = async () => {
    if (!isValid) return
    setIsLoading(true)
    try {
      await service.trainingPortal.auth.requestCode({
        companyId: company?.id,
        ...(isEmailMethod ? { email: email.trim() } : { phone }),
        accessType,
      })
      HandleSetFormData()
      handleNext()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao processar sua solicitação. Tente novamente.',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Box display="flex" flexDirection="column">
      <LoadingFeedback open={isLoading} />
      <Typography color="primary" className={classes.title}>
        Treinamento
      </Typography>
      <Typography className={classes.subtitle}>
        Escolha como deseja se identificar para acessar o treinamento.
      </Typography>

      <Box className={classes.methodToggle}>
        <Button
          variant={isEmailMethod ? 'contained' : 'outlined'}
          color="primary"
          className={
            isEmailMethod ? classes.selectedToggle : classes.unselectedToggle
          }
          onClick={() => setAuthMethod('email')}
          fullWidth
        >
          E-mail
        </Button>
        <Button
          variant={!isEmailMethod ? 'contained' : 'outlined'}
          color="primary"
          className={
            !isEmailMethod ? classes.selectedToggle : classes.unselectedToggle
          }
          onClick={() => setAuthMethod('phone')}
          fullWidth
        >
          Telefone
        </Button>
      </Box>

      {isEmailMethod ? (
        <TextField
          label="E-mail"
          placeholder="treinamento@email.com"
          variant="outlined"
          fullWidth
          type="email"
          className={classes.field}
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
        />
      ) : (
        <BasePhoneInput
          label="Telefone"
          variant="outlined"
          fullWidth
          className={classes.field}
          value={phone}
          onChange={setPhone}
        />
      )}

      <Button
        variant="contained"
        color="primary"
        fullWidth
        className={classes.submitButton}
        onClick={handleSubmit}
        disabled={!isValid || isLoading}
      >
        AVANÇAR
      </Button>
    </Box>
  )
}

export default IdentificationStep
